import * as React from 'react';
import { connect } from 'react-redux';
import ExerciseCard from '../../components/ExerciseCard/ExerciseCard';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';
import DeltaBadge from '../components/DeltaBadge';

interface IOwnProps {
  // workout id
  workoutId: number;
  // index of workout in the current session
  index: number;
  // optional add delta param to display bage
  delta?: number;
  // locked status
  locked: boolean;
}

export interface ISessionViewCardProps extends IOwnProps {
  // name of the exercise for the workout (defines title and icon)
  exerciseId: string | null;
  // show checkmark instead of the icon if completed and other styles
  completed: boolean;
  // histogram comparison value for given workout
  comparison: number | null;
}

export const SessionPageCardFC: React.FC<ISessionViewCardProps> = ({
  workoutId,
  exerciseId,
  completed,
  comparison,
  delta,
  index,
  locked,
}) => {
  const cardProps = {
    exerciseId,
    comparison,
    completed: !locked && completed,
    workoutId,
    locked,
    className: 'session-view-card col-6',
    id: `${index}-${workoutId}`,
  };
  return <ExerciseCard {...cardProps} subtitle={delta ? <DeltaBadge delta={delta} /> : ''} />;
};

export const mapStateToProps = (state: IState, { index, workoutId }: IOwnProps) => {
  const exerciseId = SessionSelectors.getExerciseName(state, workoutId);
  const completed = SessionSelectors.isWorkoutCompleted(state, index);
  const comparison = SessionSelectors.getWorkoutComparison(state, workoutId);
  return {
    exerciseId,
    completed,
    comparison,
  };
};

const SessionPageCard = connect(mapStateToProps)(SessionPageCardFC);
export default SessionPageCard;
